"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTenantByKey = void 0;
const models_1 = require("../models");
const getTenantByKey = (key) => {
    const tenantKey = key;
    return models_1.tenants[tenantKey];
};
exports.getTenantByKey = getTenantByKey;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVuYW50LnV0aWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvdGVuYW50LnV0aWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0Esc0NBQW1DO0FBRTVCLE1BQU0sY0FBYyxHQUFHLENBQUMsR0FBVyxFQUFzQixFQUFFO0lBQ2hFLE1BQU0sU0FBUyxHQUFHLEdBQTJCLENBQUE7SUFFN0MsT0FBTyxnQkFBTyxDQUFDLFNBQVMsQ0FBQyxDQUFBO0FBQzNCLENBQUMsQ0FBQTtBQUpZLFFBQUEsY0FBYyxrQkFJMUIifQ==